import store from 'store'

export const storage = {
	get: (key: string) => store.get(key),
	set: (key: string, value: string): void => {
		try {
			return store.set(key, value)
		} catch (err) {
			// silent error.
		}
	},
	remove: (key: string): void => store.remove(key),
	removeAll: (): void => {
		store.clearAll()
	}
}

export default storage
